import { defineMessages } from 'react-intl'


export default defineMessages({
  vendors: {
    defaultMessage: '{vendorCount, plural, one {# vendor} other {# vendors}}',
    id: 'tcf-label.vendors',
  },
})
